export default {
    mounted(){
        window.addEventListener('resize', ()=>{
            this.windowWidth = window.innerWidth;
        });
    },

    data(){
        return {
            windowWidth: window.innerWidth
        }
    },

    computed:{
        projectSize(){
            return {
                width: this.windowWidth + 'px',
                height:  ( (this.windowWidth / 16) * 9 ) + 'px'
            }
        },
    }
}